export var StakingHarvestModes;
(function (StakingHarvestModes) {
    StakingHarvestModes["IMMEDIATE"] = "IMMEDIATE";
    StakingHarvestModes["PER_ACCRUAL_INTERVAL"] = "PER_ACCRUAL_INTERVAL";
    StakingHarvestModes["END_OF_DURATION"] = "END_OF_DURATION";
})(StakingHarvestModes || (StakingHarvestModes = {}));
export var StakingStatuses;
(function (StakingStatuses) {
    StakingStatuses["ACTIVE"] = "ACTIVE";
    StakingStatuses["PENDING"] = "PENDING";
    StakingStatuses["DRAFT"] = "DRAFT";
    StakingStatuses["REJECTED"] = "REJECTED";
    StakingStatuses["AWAITING_REDEMPTION"] = "AWAITING_REDEMPTION";
    StakingStatuses["CLOSED"] = "CLOSED";
    StakingStatuses["CLOSED_CONTINUED"] = "CLOSED_CONTINUED";
    StakingStatuses["CLOSED_EARLY_REDEEMED"] = "CLOSED_EARLY_REDEEMED";
})(StakingStatuses || (StakingStatuses = {}));
export var StakingTypeStatuses;
(function (StakingTypeStatuses) {
    StakingTypeStatuses["ACTIVE"] = "ACTIVE";
    StakingTypeStatuses["PAUSED"] = "PAUSED";
})(StakingTypeStatuses || (StakingTypeStatuses = {}));
//# sourceMappingURL=staking.enum.js.map